export const getParamFromLocation = (nameOfParam: string) => {
  const url = new URL(window.location.href);
  return url.searchParams.get(nameOfParam);
};
